import { NgTemplateOutlet } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from "@angular/core";
import { RouterLink } from "@angular/router";
import { SvgIconComponent } from "../social-icons/svg-icon/svg-icon.component";

@Component({
  selector: "app-link",
  templateUrl: "./link.component.html",
  styleUrl: "./link.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, NgTemplateOutlet, SvgIconComponent],
})
export class LinkComponent {
  public readonly size: InputSignal<
    "x-small" | "m-small" | "small" | "medium" | "medium-2" | "medium-3" | "large"
  > = input<"x-small" | "m-small" | "small" | "medium" | "medium-2" | "medium-3" | "large">(
    "small",
  );
  public readonly variant: InputSignal<"contained" | "outlined" | "text"> = input<
    "contained" | "outlined" | "text"
  >("contained");
  public readonly type: InputSignal<"primary" | "secondary" | "tertiary"> = input<
    "primary" | "secondary" | "tertiary"
  >("primary");
  public readonly label: InputSignal<string> = input.required<string>();
  public readonly link: InputSignal<string | undefined> = input<string | undefined>();
  public readonly routerLink: InputSignal<string | undefined> = input<string | undefined>();
  public readonly icon: InputSignal<string | undefined> = input<string | undefined>();
  public readonly beforeIconPath: InputSignal<string | undefined> = input<string | undefined>();
  public readonly target: InputSignal<"_blank" | "_self"> = input<"_blank" | "_self">("_blank");
  public readonly disableRedirect: InputSignal<boolean> = input<boolean>(false);
  public readonly loading: InputSignal<boolean | undefined> = input<boolean | undefined>(false);
  public readonly linkClick: OutputEmitterRef<void> = output<void>();

  public handleClick(event: Event): void {
    if (this.disableRedirect()) {
      event.preventDefault();
      this.linkClick.emit();
    } else {
      this.linkClick.emit();
    }
  }
}
